/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import loadable from '@loadable/component';

import Advertisement from '../components/Advertisement';
import Announcements from '../components/Announcements';
import ArticleInfo from '../components/ArticleInfo';
import BaseComponent from '../components/BaseComponent';
import Breadcrumb from '../components/Breadcrumb';
import CardListWithInternalNavigation from '../components/CardListWithInternalNavigation';
import ContributorDetail from '../components/ContributorDetail';
import ContributorInfo from '../components/ContributorInfo';
import DropdownRibbonWithCta from '../components/DropdownRibbonWithCta';
import DynamicTextAndImage from '../components/DynamicTextAndImage';
import EmbedAdobeMarketoForm from '../components/EmbedAdobeMarketoForm';
import FeatureSection from '../components/FeatureSection';
import FeatureSectionWithAd from '../components/FeatureSectionWithAd';
import HomepageBanner from '../components/HomepageBanner';
import InPracticeArticleList from '../components/InPracticeArticleList';
import InpracticeTopicsList from '../components/InpracticeTopicsList';
import Logout from '../components/Logout';
import MagazineBanner from '../components/MagazineBanner';
import MagazineIssuesCarousel from '../components/MagazineIssuesCarousel';
import MagazinePageBanner from '../components/MagazinePageBanner';
import MainMenuInTheBlack from '../components/MainMenuInTheBlack';
import Metadata from '../components/Metadata';
import MetadataInTheBlack from '../components/MetadataInTheBlack';
import MMFCareerProfileForm from '../components/MMFCareerProfileForm';
import MMFContactDetailsForm from '../components/MMFContactDetailsForm';
import MobileLogout from '../components/MobileLogout';
import PageBanner from '../components/PageBanner';
import PageBannerWithInternalNavigation from '../components/PageBannerWithInternalNavigation';
import PageFooter from '../components/PageFooter';
import PageHeader from '../components/PageHeader';
import PageSlimHeader from '../components/PageSlimHeader';
import PersonalisationCarousel from '../components/PersonalisationCarousel';
import PlaceholderDashboardFullWidth from '../components/PlaceholderDashboardFullWidth';
import PlaceholderDashboardSingleColumn from '../components/PlaceholderDashboardSingleColumn';
import PlaceholderDoubleColumn from '../components/PlaceholderDoubleColumn';
import PlaceholderFullWidth from '../components/PlaceholderFullWidth';
import PlaceholderMasonryGrid from '../components/PlaceholderMasonryGrid';
import PlaceholderQuadrupleColumn from '../components/PlaceholderQuadrupleColumn';
import PlaceholderSingleColumn from '../components/PlaceholderSingleColumn';
import PlaceholderTripleColumn from '../components/PlaceholderTripleColumn';
import PodcastRelatedCards from '../components/PodcastRelatedCards';
import PodcastSeriesCards from '../components/PodcastSeriesCards';
import PodcastTuner from '../components/PodcastTuner';
import ProfilePageBanner from '../components/ProfilePageBanner';
import RecommendedInsights from '../components/RecommendedInsights';
import ResponsiveTabDropdown from '../components/ResponsiveTabDropdown';
import ShowcaseHero from '../components/ShowcaseHero';
import SponsorLogo from '../components/SponsorLogo';

const components = new Map();

  // dynamic component Accordion
  components.set('Accordion', loadable(() => import(/* webpackChunkName: "Accordion" */'../components/Accordion'), { ssr: true}))

  // standard component Advertisement
  components.set('Advertisement', Advertisement);

  // dynamic component AgendaAccordion
  components.set('AgendaAccordion', loadable(() => import(/* webpackChunkName: "AgendaAccordion" */'../components/AgendaAccordion'), { ssr: true}))

  // standard component Announcements
  components.set('Announcements', Announcements);

  // standard component ArticleInfo
  components.set('ArticleInfo', ArticleInfo);

  // dynamic component BackToTop
  components.set('BackToTop', loadable(() => import(/* webpackChunkName: "BackToTop" */'../components/BackToTop'), { ssr: true}))

  // standard component BaseComponent
  components.set('BaseComponent', BaseComponent);

  // standard component Breadcrumb
  components.set('Breadcrumb', Breadcrumb);

  // dynamic component CallToAction
  components.set('CallToAction', loadable(() => import(/* webpackChunkName: "CallToAction" */'../components/CallToAction'), { ssr: true}))

  // dynamic component CampaignNavigation
  components.set('CampaignNavigation', loadable(() => import(/* webpackChunkName: "CampaignNavigation" */'../components/CampaignNavigation'), { ssr: true}))

  // dynamic component CampaignPageBanner
  components.set('CampaignPageBanner', loadable(() => import(/* webpackChunkName: "CampaignPageBanner" */'../components/CampaignPageBanner'), { ssr: true}))

  // dynamic component CardList
  components.set('CardList', loadable(() => import(/* webpackChunkName: "CardList" */'../components/CardList'), { ssr: true}))

  // dynamic component CardListInTheBlack
  components.set('CardListInTheBlack', loadable(() => import(/* webpackChunkName: "CardListInTheBlack" */'../components/CardListInTheBlack'), { ssr: true}))

  // dynamic component CardListInTheBlackBanner
  components.set('CardListInTheBlackBanner', loadable(() => import(/* webpackChunkName: "CardListInTheBlackBanner" */'../components/CardListInTheBlackBanner'), { ssr: true}))

  // dynamic component CardListStackedImage
  components.set('CardListStackedImage', loadable(() => import(/* webpackChunkName: "CardListStackedImage" */'../components/CardListStackedImage'), { ssr: true}))

  // standard component CardListWithInternalNavigation
  components.set('CardListWithInternalNavigation', CardListWithInternalNavigation);

  // dynamic component CareerStageLearning
  components.set('CareerStageLearning', loadable(() => import(/* webpackChunkName: "CareerStageLearning" */'../components/CareerStageLearning'), { ssr: true}))

  // dynamic component ContentRelated
  components.set('ContentRelated', loadable(() => import(/* webpackChunkName: "ContentRelated" */'../components/ContentRelated'), { ssr: true}))

  // dynamic component ContentRichText
  components.set('ContentRichText', loadable(() => import(/* webpackChunkName: "ContentRichText" */'../components/ContentRichText'), { ssr: true}))

  // dynamic component ContentSummary
  components.set('ContentSummary', loadable(() => import(/* webpackChunkName: "ContentSummary" */'../components/ContentSummary'), { ssr: true}))

  // standard component ContributorDetail
  components.set('ContributorDetail', ContributorDetail);

  // standard component ContributorInfo
  components.set('ContributorInfo', ContributorInfo);

  // dynamic component CountryCourseSelector
  components.set('CountryCourseSelector', loadable(() => import(/* webpackChunkName: "CountryCourseSelector" */'../components/CountryCourseSelector'), { ssr: true}))

  // dynamic component CountryPreferenceSelector
  components.set('CountryPreferenceSelector', loadable(() => import(/* webpackChunkName: "CountryPreferenceSelector" */'../components/CountryPreferenceSelector'), { ssr: true}))

  // dynamic component CourseBanner
  components.set('CourseBanner', loadable(() => import(/* webpackChunkName: "CourseBanner" */'../components/CourseBanner'), { ssr: true}))

  // dynamic component CourseCardList
  components.set('CourseCardList', loadable(() => import(/* webpackChunkName: "CourseCardList" */'../components/CourseCardList'), { ssr: true}))

  // dynamic component CourseDetail
  components.set('CourseDetail', loadable(() => import(/* webpackChunkName: "CourseDetail" */'../components/CourseDetail'), { ssr: true}))

  // dynamic component CourseModuleContentCard
  components.set('CourseModuleContentCard', loadable(() => import(/* webpackChunkName: "CourseModuleContentCard" */'../components/CourseModuleContentCard'), { ssr: true}))

  // dynamic component CourseOverview
  components.set('CourseOverview', loadable(() => import(/* webpackChunkName: "CourseOverview" */'../components/CourseOverview'), { ssr: true}))

  // dynamic component CourseSession
  components.set('CourseSession', loadable(() => import(/* webpackChunkName: "CourseSession" */'../components/CourseSession'), { ssr: true}))

  // dynamic component CourseStickyPanel
  components.set('CourseStickyPanel', loadable(() => import(/* webpackChunkName: "CourseStickyPanel" */'../components/CourseStickyPanel'), { ssr: true}))

  // dynamic component CoveoContentCards
  components.set('CoveoContentCards', loadable(() => import(/* webpackChunkName: "CoveoContentCards" */'../components/CoveoContentCards'), { ssr: false}))

  // dynamic component CPDTracker
  components.set('CPDTracker', loadable(() => import(/* webpackChunkName: "CPDTracker" */'../components/CPDTracker'), { ssr: false}))

  // dynamic component CredentialBanner
  components.set('CredentialBanner', loadable(() => import(/* webpackChunkName: "CredentialBanner" */'../components/CredentialBanner'), { ssr: true}))

  // dynamic component CurrentCardContainer
  components.set('CurrentCardContainer', loadable(() => import(/* webpackChunkName: "CurrentCardContainer" */'../components/CurrentCardContainer'), { ssr: true}))

  // dynamic component DashboardNavigation
  components.set('DashboardNavigation', loadable(() => import(/* webpackChunkName: "DashboardNavigation" */'../components/DashboardNavigation'), { ssr: true}))

  // dynamic component DateLinkList
  components.set('DateLinkList', loadable(() => import(/* webpackChunkName: "DateLinkList" */'../components/DateLinkList'), { ssr: true}))

  // dynamic component DocumentList
  components.set('DocumentList', loadable(() => import(/* webpackChunkName: "DocumentList" */'../components/DocumentList'), { ssr: true}))

  // standard component DropdownRibbonWithCta
  components.set('DropdownRibbonWithCta', DropdownRibbonWithCta);

  // standard component DynamicTextAndImage
  components.set('DynamicTextAndImage', DynamicTextAndImage);

  // standard component EmbedAdobeMarketoForm
  components.set('EmbedAdobeMarketoForm', EmbedAdobeMarketoForm);

  // dynamic component EmbeddedCoveoSearch
  components.set('EmbeddedCoveoSearch', loadable(() => import(/* webpackChunkName: "EmbeddedCoveoSearch" */'../components/EmbeddedCoveoSearch'), { ssr: true}))

  // standard component FeatureSection
  components.set('FeatureSection', FeatureSection);

  // standard component FeatureSectionWithAd
  components.set('FeatureSectionWithAd', FeatureSectionWithAd);

  // dynamic component Form
  components.set('Form', loadable(() => import(/* webpackChunkName: "Form" */'../components/Form'), { ssr: true}))

  // dynamic component FullWidthImagePageBanner
  components.set('FullWidthImagePageBanner', loadable(() => import(/* webpackChunkName: "FullWidthImagePageBanner" */'../components/FullWidthImagePageBanner'), { ssr: true}))

  // dynamic component HeroBanner
  components.set('HeroBanner', loadable(() => import(/* webpackChunkName: "HeroBanner" */'../components/HeroBanner'), { ssr: true}))

  // dynamic component HiddenRendering
  components.set('HiddenRendering', loadable(() => import(/* webpackChunkName: "HiddenRendering" */'../components/HiddenRendering'), { ssr: true}))

  // standard component HomepageBanner
  components.set('HomepageBanner', HomepageBanner);

  // dynamic component Icon
  components.set('Icon', loadable(() => import(/* webpackChunkName: "Icon" */'../components/Icon'), { ssr: true}))

  // dynamic component IFrame
  components.set('IFrame', loadable(() => import(/* webpackChunkName: "IFrame" */'../components/IFrame'), { ssr: true}))

  // dynamic component ImageCardGrid
  components.set('ImageCardGrid', loadable(() => import(/* webpackChunkName: "ImageCardGrid" */'../components/ImageCardGrid'), { ssr: true}))

  // dynamic component ImageWithTitleAndText
  components.set('ImageWithTitleAndText', loadable(() => import(/* webpackChunkName: "ImageWithTitleAndText" */'../components/ImageWithTitleAndText'), { ssr: true}))

  // dynamic component InformationSession
  components.set('InformationSession', loadable(() => import(/* webpackChunkName: "InformationSession" */'../components/InformationSession'), { ssr: true}))

  // dynamic component InPageBanner
  components.set('InPageBanner', loadable(() => import(/* webpackChunkName: "InPageBanner" */'../components/InPageBanner'), { ssr: true}))

  // standard component InPracticeArticleList
  components.set('InPracticeArticleList', InPracticeArticleList);

  // standard component InpracticeTopicsList
  components.set('InpracticeTopicsList', InpracticeTopicsList);

  // dynamic component IntegratedReportCollapsibleProfiles
  components.set('IntegratedReportCollapsibleProfiles', loadable(() => import(/* webpackChunkName: "IntegratedReportCollapsibleProfiles" */'../components/IntegratedReportCollapsibleProfiles'), { ssr: true}))

  // dynamic component IntegratedReportNavigation
  components.set('IntegratedReportNavigation', loadable(() => import(/* webpackChunkName: "IntegratedReportNavigation" */'../components/IntegratedReportNavigation'), { ssr: true}))

  // dynamic component IntegratedReportTwoColumnBanner
  components.set('IntegratedReportTwoColumnBanner', loadable(() => import(/* webpackChunkName: "IntegratedReportTwoColumnBanner" */'../components/IntegratedReportTwoColumnBanner'), { ssr: true}))

  // dynamic component InternalPageBanner
  components.set('InternalPageBanner', loadable(() => import(/* webpackChunkName: "InternalPageBanner" */'../components/InternalPageBanner'), { ssr: true}))

  // dynamic component LargeTitleDescription
  components.set('LargeTitleDescription', loadable(() => import(/* webpackChunkName: "LargeTitleDescription" */'../components/LargeTitleDescription'), { ssr: true}))

  // dynamic component LateralNavigation
  components.set('LateralNavigation', loadable(() => import(/* webpackChunkName: "LateralNavigation" */'../components/LateralNavigation'), { ssr: true}))

  // dynamic component LinkList
  components.set('LinkList', loadable(() => import(/* webpackChunkName: "LinkList" */'../components/LinkList'), { ssr: true}))

  // dynamic component ListArticle
  components.set('ListArticle', loadable(() => import(/* webpackChunkName: "ListArticle" */'../components/ListArticle'), { ssr: true}))

  // standard component Logout
  components.set('Logout', Logout);

  // standard component MagazineBanner
  components.set('MagazineBanner', MagazineBanner);

  // standard component MagazineIssuesCarousel
  components.set('MagazineIssuesCarousel', MagazineIssuesCarousel);

  // standard component MagazinePageBanner
  components.set('MagazinePageBanner', MagazinePageBanner);

  // dynamic component MainMenu
  components.set('MainMenu', loadable(() => import(/* webpackChunkName: "MainMenu" */'../components/MainMenu'), { ssr: true}))

  // standard component MainMenuInTheBlack
  components.set('MainMenuInTheBlack', MainMenuInTheBlack);

  // dynamic component MainSearch
  components.set('MainSearch', loadable(() => import(/* webpackChunkName: "MainSearch" */'../components/MainSearch'), { ssr: true}))

  // dynamic component MasonryGrid
  components.set('MasonryGrid', loadable(() => import(/* webpackChunkName: "MasonryGrid" */'../components/MasonryGrid'), { ssr: true}))

  // dynamic component MediaEmbed
  components.set('MediaEmbed', loadable(() => import(/* webpackChunkName: "MediaEmbed" */'../components/MediaEmbed'), { ssr: true}))

  // dynamic component MenuButton
  components.set('MenuButton', loadable(() => import(/* webpackChunkName: "MenuButton" */'../components/MenuButton'), { ssr: true}))

  // standard component Metadata
  components.set('Metadata', Metadata);

  // standard component MetadataInTheBlack
  components.set('MetadataInTheBlack', MetadataInTheBlack);

  // dynamic component MicrocredentialTopic
  components.set('MicrocredentialTopic', loadable(() => import(/* webpackChunkName: "MicrocredentialTopic" */'../components/MicrocredentialTopic'), { ssr: true}))

  // dynamic component MMFBPPAssessment
  components.set('MMFBPPAssessment', loadable(() => import(/* webpackChunkName: "MMFBPPAssessment" */'../components/MMFBPPAssessment'), { ssr: true}))

  // standard component MMFCareerProfileForm
  components.set('MMFCareerProfileForm', MMFCareerProfileForm);

  // standard component MMFContactDetailsForm
  components.set('MMFContactDetailsForm', MMFContactDetailsForm);

  // dynamic component MMFCPDTracker
  components.set('MMFCPDTracker', loadable(() => import(/* webpackChunkName: "MMFCPDTracker" */'../components/MMFCPDTracker'), { ssr: false}))

  // dynamic component MMFMemberDetails
  components.set('MMFMemberDetails', loadable(() => import(/* webpackChunkName: "MMFMemberDetails" */'../components/MMFMemberDetails'), { ssr: false}))

  // dynamic component MMFMembershipRenewalForm
  components.set('MMFMembershipRenewalForm', loadable(() => import(/* webpackChunkName: "MMFMembershipRenewalForm" */'../components/MMFMembershipRenewalForm'), { ssr: true}))

  // dynamic component MMFMembershipRenewalForm2023
  components.set('MMFMembershipRenewalForm2023', loadable(() => import(/* webpackChunkName: "MMFMembershipRenewalForm2023" */'../components/MMFMembershipRenewalForm2023'), { ssr: true}))

  // dynamic component MMFProgramTracker
  components.set('MMFProgramTracker', loadable(() => import(/* webpackChunkName: "MMFProgramTracker" */'../components/MMFProgramTracker'), { ssr: false}))

  // dynamic component MobileBanner
  components.set('MobileBanner', loadable(() => import(/* webpackChunkName: "MobileBanner" */'../components/MobileBanner'), { ssr: true}))

  // standard component MobileLogout
  components.set('MobileLogout', MobileLogout);

  // dynamic component Modal
  components.set('Modal', loadable(() => import(/* webpackChunkName: "Modal" */'../components/Modal'), { ssr: true}))

  // dynamic component MultiEventBanner
  components.set('MultiEventBanner', loadable(() => import(/* webpackChunkName: "MultiEventBanner" */'../components/MultiEventBanner'), { ssr: true}))

  // dynamic component MultiMediaEmbed
  components.set('MultiMediaEmbed', loadable(() => import(/* webpackChunkName: "MultiMediaEmbed" */'../components/MultiMediaEmbed'), { ssr: true}))

  // dynamic component NavItem
  components.set('NavItem', loadable(() => import(/* webpackChunkName: "NavItem" */'../components/NavItem'), { ssr: true}))

  // dynamic component NewSocialShare
  components.set('NewSocialShare', loadable(() => import(/* webpackChunkName: "NewSocialShare" */'../components/NewSocialShare'), { ssr: true}))

  // dynamic component PaddingSpacer
  components.set('PaddingSpacer', loadable(() => import(/* webpackChunkName: "PaddingSpacer" */'../components/PaddingSpacer'), { ssr: true}))

  // standard component PageBanner
  components.set('PageBanner', PageBanner);

  // standard component PageBannerWithInternalNavigation
  components.set('PageBannerWithInternalNavigation', PageBannerWithInternalNavigation);

  // dynamic component PageBannerWithNews
  components.set('PageBannerWithNews', loadable(() => import(/* webpackChunkName: "PageBannerWithNews" */'../components/PageBannerWithNews'), { ssr: true}))

  // standard component PageFooter
  components.set('PageFooter', PageFooter);

  // standard component PageHeader
  components.set('PageHeader', PageHeader);

  // standard component PageSlimHeader
  components.set('PageSlimHeader', PageSlimHeader);

  // dynamic component PartnerTicker
  components.set('PartnerTicker', loadable(() => import(/* webpackChunkName: "PartnerTicker" */'../components/PartnerTicker'), { ssr: true}))

  // standard component PersonalisationCarousel
  components.set('PersonalisationCarousel', PersonalisationCarousel);

  // dynamic component PillLinkList
  components.set('PillLinkList', loadable(() => import(/* webpackChunkName: "PillLinkList" */'../components/PillLinkList'), { ssr: true}))

  // standard component PlaceholderDashboardFullWidth
  components.set('PlaceholderDashboardFullWidth', PlaceholderDashboardFullWidth);

  // standard component PlaceholderDashboardSingleColumn
  components.set('PlaceholderDashboardSingleColumn', PlaceholderDashboardSingleColumn);

  // standard component PlaceholderDoubleColumn
  components.set('PlaceholderDoubleColumn', PlaceholderDoubleColumn);

  // standard component PlaceholderFullWidth
  components.set('PlaceholderFullWidth', PlaceholderFullWidth);

  // standard component PlaceholderMasonryGrid
  components.set('PlaceholderMasonryGrid', PlaceholderMasonryGrid);

  // standard component PlaceholderQuadrupleColumn
  components.set('PlaceholderQuadrupleColumn', PlaceholderQuadrupleColumn);

  // standard component PlaceholderSingleColumn
  components.set('PlaceholderSingleColumn', PlaceholderSingleColumn);

  // standard component PlaceholderTripleColumn
  components.set('PlaceholderTripleColumn', PlaceholderTripleColumn);

  // dynamic component PodcastEpisode
  components.set('PodcastEpisode', loadable(() => import(/* webpackChunkName: "PodcastEpisode" */'../components/PodcastEpisode'), { ssr: true}))

  // standard component PodcastRelatedCards
  components.set('PodcastRelatedCards', PodcastRelatedCards);

  // standard component PodcastSeriesCards
  components.set('PodcastSeriesCards', PodcastSeriesCards);

  // dynamic component PodcastSubscription
  components.set('PodcastSubscription', loadable(() => import(/* webpackChunkName: "PodcastSubscription" */'../components/PodcastSubscription'), { ssr: true}))

  // standard component PodcastTuner
  components.set('PodcastTuner', PodcastTuner);

  // standard component ProfilePageBanner
  components.set('ProfilePageBanner', ProfilePageBanner);

  // dynamic component ProgramTracker
  components.set('ProgramTracker', loadable(() => import(/* webpackChunkName: "ProgramTracker" */'../components/ProgramTracker'), { ssr: false}))

  // standard component RecommendedInsights
  components.set('RecommendedInsights', RecommendedInsights);

  // standard component ResponsiveTabDropdown
  components.set('ResponsiveTabDropdown', ResponsiveTabDropdown);

  // dynamic component SearchBar
  components.set('SearchBar', loadable(() => import(/* webpackChunkName: "SearchBar" */'../components/SearchBar'), { ssr: true}))

  // dynamic component SearchMenu
  components.set('SearchMenu', loadable(() => import(/* webpackChunkName: "SearchMenu" */'../components/SearchMenu'), { ssr: true}))

  // dynamic component SearchMenuButton
  components.set('SearchMenuButton', loadable(() => import(/* webpackChunkName: "SearchMenuButton" */'../components/SearchMenuButton'), { ssr: true}))

  // dynamic component SearchResults
  components.set('SearchResults', loadable(() => import(/* webpackChunkName: "SearchResults" */'../components/SearchResults'), { ssr: false}))

  // dynamic component SearchResultsInTheBlack
  components.set('SearchResultsInTheBlack', loadable(() => import(/* webpackChunkName: "SearchResultsInTheBlack" */'../components/SearchResultsInTheBlack'), { ssr: false}))

  // standard component ShowcaseHero
  components.set('ShowcaseHero', ShowcaseHero);

  // dynamic component SingleImage
  components.set('SingleImage', loadable(() => import(/* webpackChunkName: "SingleImage" */'../components/SingleImage'), { ssr: true}))

  // standard component SponsorLogo
  components.set('SponsorLogo', SponsorLogo);

  // dynamic component StaticTextAndImage
  components.set('StaticTextAndImage', loadable(() => import(/* webpackChunkName: "StaticTextAndImage" */'../components/StaticTextAndImage'), { ssr: true}))

  // dynamic component StudyPlanner
  components.set('StudyPlanner', loadable(() => import(/* webpackChunkName: "StudyPlanner" */'../components/StudyPlanner'), { ssr: false}))

  // dynamic component TabComponent
  components.set('TabComponent', loadable(() => import(/* webpackChunkName: "TabComponent" */'../components/TabComponent'), { ssr: true}))

  // dynamic component Tabs
  components.set('Tabs', loadable(() => import(/* webpackChunkName: "Tabs" */'../components/Tabs'), { ssr: true}))

  // dynamic component TagList
  components.set('TagList', loadable(() => import(/* webpackChunkName: "TagList" */'../components/TagList'), { ssr: true}))

  // dynamic component TimezoneSelector
  components.set('TimezoneSelector', loadable(() => import(/* webpackChunkName: "TimezoneSelector" */'../components/TimezoneSelector'), { ssr: true}))

  // dynamic component TrendingCardList
  components.set('TrendingCardList', loadable(() => import(/* webpackChunkName: "TrendingCardList" */'../components/TrendingCardList'), { ssr: true}))

  // dynamic component VisualLinkText
  components.set('VisualLinkText', loadable(() => import(/* webpackChunkName: "VisualLinkText" */'../components/VisualLinkText'), { ssr: true}))

export default function componentFactory(componentName) {
  return components.get(componentName);
};
